import { Divider } from '@mui/material'
import Form from '../../../components/Form'
import { useForm } from 'react-hook-form'
import FormItem from '../../../components/Form/FormItem'
import SelectOfCategories from '../../../components/Inputs/SelectOfCategories'
import InputNumber from '../../../components/Inputs/InputNumber'
import Button from '../../../components/General/Button'
import React, { useEffect, useState } from 'react'
import InputText from '../../../components/Inputs/InputText'
import { formatPipe } from '../../../utils/utils'
import { IGlobalRate } from '../../../views/Sells/Sells'
import { toFixed } from 'accounting'

interface IIGTFForm {
    onCancel: () => void
    rate: IGlobalRate[]
    onSubmit: (igtf: number) => void
}

export const IGTFForm: React.FC<IIGTFForm> = ({ onCancel, onSubmit, rate }) => {
  const form = useForm<any>({
    defaultValues: {
        usd: 0,
        cop: 0,
        eur: 0,
    },
  })

  const [igtfValue, setIgtfValue] = useState<number>(0)

  useEffect(() => {
    console.log('form', form.getValues())
    //id = 1
    let usd = formatPipe(form.getValues('usd')+"", true)
    //id = 4
    let cop = formatPipe(form.getValues('cop') + "", true)
    //id = 3
    let eur = formatPipe(form.getValues('eur') + "", true)
    // console.log('usd', usd)
    // console.log('usd', cop)
    // console.log('usd', eur)

    let result =
      +usd * +onGetByCurrency('1') +
      +cop * +onGetByCurrency('4') +
      +eur * +onGetByCurrency('3')
    // console.log('1', +onGetByCurrency('1'))
    // console.log('4', +onGetByCurrency('4'))
    // console.log('3', +onGetByCurrency('3'))

    console.log('result', result)
    console.log('rate..', rate)
    setIgtfValue(+toFixed(result * 0.03, 2))
  }, [form.watch()])

  const onGetByCurrency = (id: string): string =>
  rate.find((v) => v.id === id)?.rate || '0'

  return (
    <div>
      <label className="text-primary font-semibold mb-2">IGTF</label>

      <Form
        classes="gap-x-6 mt-4"
        form={form}
        onSubmit={() => {
            onCancel()
            onSubmit(igtfValue)
          }}
      >
        <FormItem name="usd" classes="col-span-12">
          <InputNumber label="DÓLARES" addDecimals={true} />
        </FormItem>
        <FormItem name="cop" classes="col-span-12" defaultValue={'0'}>
          <InputNumber label="PESOS" addDecimals={true} />
        </FormItem>
        <FormItem name="eur" classes="col-span-12" defaultValue={'0'}>
          <InputNumber label="EUROS" addDecimals={true} />
        </FormItem>

        <div className="col-span-12 flex mt-4">
          <Button
            type="outline"
            classes="w-1/2 mr-5"
            onClick={onCancel}
            htmlType="button"
          >
            Cancelar
          </Button>

          <Button type="primary" classes="w-1/2" htmlType="submit">
            Continuar
          </Button>
        </div>
      </Form>
    </div>
  )
}
